import { useQuery } from "@tanstack/react-query";
import { apiClient, type ListingsQuery } from "../lib/api-client";
import { queryKeys } from "../lib/queryClient";

export function useSellerRating(sellerId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.sellerRating(sellerId ?? ""),
    queryFn: ({ signal }) => apiClient.getSellerRating(sellerId as string, signal),
    enabled: Boolean(sellerId),
  });
}

export function useSellerReviews(sellerId: string | undefined, query: ListingsQuery = {}) {
  return useQuery({
    queryKey: queryKeys.sellerReviews(sellerId ?? ""),
    queryFn: ({ signal }) => apiClient.getSellerReviews(sellerId as string, query, signal),
    enabled: Boolean(sellerId),
  });
}
